<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div v-if="noEdit" class="table-name-edit" @mouseenter="editShow" @mouseleave="editShow">
    <div :title="oldName" class="table-name-edit-name textEllipsis">{{ oldName == ''? '--': oldName }}</div>
    <div class="table-name-edit-icon">
      <a v-show="showEdit" class="icon" @click="startEdit">
        <Icon type="ios-create-outline" size="16"></Icon>
      </a>
    </div>
  </div>

  <div v-else class="table-name-edit-box">
    <Input :maxlength="128" v-model="changeName" style="width:140px;" :placeholder="$t('common.input')" size="small"></Input>
    <Button type="info" size="small" @click="onChangeName">{{ $t('filter.confirm') }}</Button>
    <Button type="text" size="small" @click="closeEdit">{{ $t('filter.cancel') }}</Button>
  </div>
</template>
<script>
  import bus from '../../libs/bus';
  import util from '../../libs/util';

  /* 二维码管理修改名称组件 */
  export default {
    props: {
      name: String,
      qcodeId: String,
      tableData: Array,
    },
    data() {
      return {
        showEdit: false,
        noEdit: true,
        oldName: this.name,
        changeName: '',
      };
    },
    mounted() {
      bus.$on('on-close-edit', (id) => {
        if (id !== this.qcodeId) this.closeEdit();
      });
    },
    methods: {
      editShow() {
        this.showEdit = !this.showEdit;
      },
      // 点击编辑icon执行
      startEdit() {
        this.noEdit = false;
        this.$emit('on-change-edit', this.qcodeId);
      },
      // 点击确定按钮执行
      onChangeName() {
        // demo环境下不允许操作
        if (bus.demoTip()) return;
        // 遍历表格中二维码名称是否存在
        let flag = false;
        this.tableData.forEach((v) => {
          if (v.qcodeNm === this.changeName) flag = true;
        });
        if (flag) {
          this.$Message.error({
            content: this.$t('qrcodeManage.codeModal.warning.codeIsExisted'),
            duration: 5,
          });
          return;
        }

        // 二维码名称验证，只能为英文、中文、数字
        const reg = new RegExp('^[A-Za-z0-9\u4e00-\u9fa5]+$');
        if (!reg.test(this.changeName)) {
          this.$Message.warning({
            content: this.$t('qrcodeManage.codeModal.warning.codeError'),
            duration: 5,
          });
          return;
        }
        const params = {
          qcodeId: this.qcodeId,
          productId: bus.productid,
          qcodeNm: this.changeName,
        };
        util.ajax.post('/app/rest/miniApp/qcode/update', params).then(() => {
          this.oldName = this.changeName;
          this.$emit('on-change-name-succ', this.qcodeId, this.changeName);
          this.$Message.success({
            content: this.$t('exploration.tip.tip2'),
            duration: 3,
          });
          this.closeEdit();
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.updateFailed'),
              duration: 3,
            });
          }
        });
      },
      // 点击取消按钮执行
      closeEdit() {
        this.noEdit = true;
        this.showEdit = false;
        this.changeName = '';
      },
    },
    filters: {},
  };
</script>
